import { render, staticRenderFns } from "./NoAccess.vue?vue&type=template&id=130bc7da&scoped=true&"
import script from "./NoAccess.vue?vue&type=script&lang=js&"
export * from "./NoAccess.vue?vue&type=script&lang=js&"
import style0 from "./NoAccess.vue?vue&type=style&index=0&id=130bc7da&prod&lang=css&"
import style1 from "./NoAccess.vue?vue&type=style&index=1&id=130bc7da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130bc7da",
  null
  
)

export default component.exports